import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux'
import diagnosis from './reducers'

import { createStore, applyMiddleware } from 'redux'

import createSagaMiddleware from 'redux-saga'

import sagas from './sagas/sagas'

// import moment from 'moment/min/moment-with-locales';
// import Moment from 'react-moment';
 
// // Sets the moment instance to use.
// Moment.globalMoment = moment;
// Moment.globalLocale = 'es';
// Moment.globalElement = 'span';

function ignoreerror()
{
   return true
}

window.onerror=ignoreerror();

// create the saga middleware
const sagaMiddleware = createSagaMiddleware()
// mount it on the Store
const store = createStore(diagnosis,
  applyMiddleware(sagaMiddleware)
)

// then run the saga
sagaMiddleware.run(sagas)


ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>
    , document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
